
const dev = {
  awsRegion: 'us-east-1',
  googleAnalyticsId: 'UA-47128313-3',
  googleAnalyticsSampleRate: 100,
  googleAnalyticsSpeedSampleRate: 100,
  cognitoIdentityPoolId: 'us-east-1:26b613b0-4102-4fc8-b1a7-671d45c4fc55',
  apiGatewayEndpoint: 'https://csp-api-dev.courtyardstone.com/dev',
  googleSignInParams: {
    client_id: '138058417459-22ti90ahel84u8ck2uh67c1dpoa7i1v0.apps.googleusercontent.com'
  },
  facebookSignInParams: {
    init: {
      appId: '1731673160466541',
      cookie: true,
      xfbml: false,
      version: 'v2.9'
    },
    login: {
      scope: 'public_profile,email'
    }
  },
  amazonSignInParams: {
    clientId: 'amzn1.application-oa2-client.d3a14687e98945abb7e67372131d204b',
    scope: 'profile'
  },
  signinTimeout: 5000,
  website: 'https://www-dev.courtyardstone.com'
}

export default dev



// WEBPACK FOOTER //
// ./src/store/config/dev.js